/**
 * utils/errorText.js — turn an axios failure into something actionable.
 *
 * Plenty of call sites used to swallow the error entirely
 * (`catch { toast.error("Failed to load") }`), which told the user nothing
 * and left nothing to debug in the notification history. This keeps the
 * short human label and appends what the server actually said.
 */

const OFFLINE = "connessione al server non riuscita";

export function errorText(err, fallback = "Operazione non riuscita") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return `${fallback}: ${detail}`;
  // FastAPI validation errors arrive as a list of objects.
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    const where = Array.isArray(first?.loc) ? first.loc.slice(-1)[0] : null;
    const msg = first?.msg || "dato non valido";
    return `${fallback}: ${where ? `${where} — ` : ""}${msg}`;
  }
  const status = err?.response?.status;
  if (status === 401) return `${fallback}: sessione scaduta, accedi di nuovo`;
  if (status === 403) return `${fallback}: non hai i permessi necessari`;
  if (status === 404) return `${fallback}: risorsa non trovata`;
  if (status === 429) return `${fallback}: troppe richieste, riprova più tardi`;
  if (status >= 500) return `${fallback}: errore del server (${status})`;
  if (!err?.response) return `${fallback}: ${OFFLINE}`;
  return fallback;
}

export default errorText;
